import { render } from "./mls-disclaimer-v2.vue?vue&type=template&id=a34b642e"
import script from "./mls-disclaimer-v2.vue?vue&type=script&lang=js"
export * from "./mls-disclaimer-v2.vue?vue&type=script&lang=js"

import "./mls-disclaimer-v2.vue?vue&type=style&index=0&id=a34b642e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-footer/mls-disclaimer-v2.vue'],['render',render],['__file',"mls-disclaimer-v2.vue"]])

export default __exports__